import script from "./InputRating.vue?vue&type=script&setup=true&lang=js"
export * from "./InputRating.vue?vue&type=script&setup=true&lang=js"

import "./InputRating.vue?vue&type=style&index=0&id=704929ac&lang=scss"

const __exports__ = script;

export default __exports__